var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.countdown.finished
      ? _c("div", { attrs: { role: "alert" } }, [
          _c("div", {
            domProps: {
              innerHTML: _vm._s(
                _vm.$translate("Bigtex5::Template.deliveryNextWorkingDay")
              )
            }
          })
        ])
      : _c("div", [
          _c("div", {
            domProps: {
              innerHTML: _vm._s(
                _vm.$translate("Bigtex5::Template.deliveryTimer", {
                  hour: _vm.countdown.hours,
                  minutes: _vm.countdown.minutes
                })
              )
            }
          })
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }